import React from "react";
import { Tag } from "antd";
import { MdWarning } from "react-icons/md";

interface SetStatusProps {
  stageId: number;
  archived?: string | boolean;
  isDuplicate?: boolean;
}

const SetStatus: React.FC<SetStatusProps> = ({
  stageId,
  archived,
  isDuplicate,
}) => {
  const ARCHIEVE_STATUS = {
    UNARCHIEVED: "UnArchived",
    ARCHIEVED: "Archived",
    ALREADY_EXPORTED: "AlreadyExported",
    DEFAULT: "Default",
  };
  let color: string;
  let status: string;

  if (archived === "Reconciled") {
    color = "#218661";
    status = "Reconciled";
  } else if (archived === "Archive") {
    color = "#6b7280";
    status = "Archive";
  } else if (archived === "Archived" || archived === true) {
    color = "volcano";
    status = "Archived";
  } else if (archived === "UnArchived" || archived === false) {
    color = "gold";
    status = "UnArchived";
  } else if (archived === "AlreadyExported") {
    color = "grey";
    status = "Exported";
  } else {
    switch (stageId) {
      // case 0:
      //   color = "lime";
      //   status = "Pending";
      //   break;
      case 11:
        color = "yellow";
        status = "New";
        break;
      case 12:
        color = "green";
        status = "Viewed";
        break;
      case 13:
        color = "orange";
        status = "Edited";
        break;
         case 14:
        color = "blue";
        status = "To-review";
        break;
      case 21:
        color = "grey";
        status = "Ready";
        break;
      case 22:
        if (
          (archived && archived === ARCHIEVE_STATUS.DEFAULT) ||
          archived == undefined
        ) {
          color = "grey";
          status = "Exported";
          break;
        }
        // if the Archieve is not default it has been changed, Arhieved, UnArchieved,
        if (archived && archived == ARCHIEVE_STATUS.ALREADY_EXPORTED) {
          color = "grey";
          status = "Exported";
          break;
        }
        color = "blue";
        status = "Unassigned";
        break;

      // case 5:
      //   color = "blue";
      //   status = "Approved";
      //   break;
      // case 6:
      //   color = "red";
      //   status = "Rejected";
      //   break;
      // case 7:
      //   color = "purple";
      //   status = "Processing";
      //   break;
      // case 8:
      //   color = "geekblue";
      //   status = "In Progress";
      //   break;
      // case 9:
      //   color = "magenta";
      //   status = "Cancelled";
      //   break;
      default:
        color = "blue";
        status = "Unassigned";
    }
  }

  return (
    <>
      <Tag color={color}>{status}</Tag>
      {isDuplicate && (
        <Tag
          color="red"
          icon={<MdWarning style={{ verticalAlign: "-2px" }} />}
        >
          Duplicate
        </Tag>
      )}
    </>
  );
};

export default SetStatus;
